import { baseURL } from '..';
import { IProject, IProjectInfo } from '../../shared/iProject';
import httpClient, { IPaginatedResponse, IResponse } from '../httpClient';
import { createHeaders, createRequest, paginationQuery } from '../util';
import { ICreateProjectRequest, IGetProjectPreviewResponse } from './iApiResponse';

const ProjectProvider = () => {
    const createProjectAsync = (payload: ICreateProjectRequest): Promise<IResponse<IProject>> => httpClient.postAsync(createRequest(baseURL, `/Project/CreateProject`, payload), createHeaders());

    const getProjectPreviewAsync = (email: string, pageNumber?: number, pageSize?: number, name?: string): Promise<IResponse<IPaginatedResponse<IGetProjectPreviewResponse>>> =>
        httpClient.getAsync(
            createRequest(baseURL, `/Project/GetPaginatedProjectPreviewsByAuthorEmail?authorEmail=${email}`, undefined, paginationQuery(pageNumber, pageSize, name, true)),
            createHeaders(),
        );

    const getProjectAsync = (id: number, email: string): Promise<IResponse<IProject>> =>
        httpClient.getAsync(createRequest(baseURL, `/Project/GetProjectByAuthorEmail?id=${id}&email=${email}`), createHeaders());

    const getProjectTemplatesAsync = (): Promise<IResponse<IProject[]>> => httpClient.getAsync(createRequest(baseURL, `/Project/GetProjectTemplates`), createHeaders());

    const deleteProjectAsync = (id: number, email: string): Promise<IResponse> =>
        httpClient.deleteAsync(createRequest(baseURL, `/Project/SoftDeleteProject?id=${id}&authorEmail=${email}`), createHeaders());

    const updateProjectAsync = (payload: IProject): Promise<IResponse<IProject>> => httpClient.putAsync(createRequest(baseURL, `/Project/UpdateProject`, payload), createHeaders());

    const composeProjectAsync = (payload: IProjectInfo): Promise<IResponse<IProject>> => httpClient.postAsync(createRequest(baseURL, `/Project/ComposeProject`, payload), createHeaders());

    const createFromExistingProjectAsync = (project: IProject, authorEmail: string): Promise<IResponse<IProject>> =>
        httpClient.postAsync(createRequest(baseURL, `/Project/createFromExistingProject?authorEmail=${authorEmail}`, project), createHeaders());

    return { createFromExistingProjectAsync, getProjectTemplatesAsync, getProjectPreviewAsync, createProjectAsync, getProjectAsync, deleteProjectAsync, updateProjectAsync, composeProjectAsync };
};

export default ProjectProvider();
